import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  selected: boolean
}

const RadioInput = (props: Props) => {
  const { selected } = props

  return (
    <div className={`RadioInput_checkbox_${selected ? 'selected' : 'default'}`}>
      {selected && (
        <span className={'RadioInput_iconWrapper'}>
          <Icon.Medium icon="check" color="grey000White" />
        </span>
      )}
    </div>
  )
}

export default RadioInput
